import { css } from 'emotion'

export const iconStyles = css`
  height: 1em;
`
